// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"CategoryGrid_sectionHeader__CyhnP","sectionTitle":"CategoryGrid_sectionTitle__uauGR"};